// Libs
import React from 'react'
import classNames from 'classnames'

// CSS
import "./styles.scss"

const LoadingIcon = ({ type, size, spaceBetweenDots }) => {
  const loadingIconStyle = {
    width: `${size}px`,
    height: `${size}px`,
    margin: `0 ${spaceBetweenDots}px`
  }

  const loadingIconClassName = classNames(
    'loading-icon',
    {
      'loading-icon--page': type === 'page',
      'loading-icon--grey': type === 'grey'
    }
  )

  return (
    <div className={loadingIconClassName}>
      <div style={loadingIconStyle} className="loading-icon__dot"></div>
      <div style={loadingIconStyle} className="loading-icon__dot"></div>
      <div style={loadingIconStyle} className="loading-icon__dot"></div>
    </div>
  )
}

export default LoadingIcon
